module.exports = __webpack_public_path__ + "img/YinXiang.0c99e4f9.png";